module.exports = __webpack_public_path__ + "img/img-form-productos.3cc45c8e.webp";